export default {
	"font": "sans-serif",
	"primary-highlight-color": "#d7cefd",
	"secondary-highlight-color": "#9980fa",
	"main-color": "#353b48",
	"bg-color": "#fff",
	"accent-color": "#efefef",
	"scrollbar-color": "#9980fa",
};
